let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ePp1D")).then(() => parcelRequire('eRdPG'));